export default "__VITE_ASSET__9ca8c22d__"